
















































import { Component, Vue } from "vue-property-decorator";
import { DialogsModule } from "@/store/dialogs.module";
import { ContractsService } from "@/services/api/contracts.service";

@Component
export default class DebtNoticeModal extends Vue {
  loadingDelivery: boolean = false;
  get debtNotice() {
    return DialogsModule.debtNoticeModal;
  }

  async close() {
    this.loadingDelivery = true;

    if (this.debtNotice.contract) {
      await ContractsService.setDebtNoticeDelivery(this.debtNotice.contract);
    }

    this.loadingDelivery = false;
    DialogsModule.unsetDebtNoticeModal();
    this.$router.push({ name: "debt-notifications" });
  }
}
